<div class="dialog-container">
  <div class="header">
    <div class="text-xl font-bold">Appeal Number</div>
    <button mat-icon-button class="close-icon" (click)="onCancel()" disableRipple>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Table Section -->
  <div class="table-section">
    <div class="px-0">
      <table mat-table [dataSource]="caseData" class="virtual-scroll">

        <!-- Case Number Column -->
        <ng-container matColumnDef="caseNumber">
          <th mat-header-cell *matHeaderCellDef class="sticky-header">Case Number</th>
          <td mat-cell *matCellDef="let row">{{ row.caseNumber }}</td>
        </ng-container>

        <!-- Case Category Column -->
        <ng-container matColumnDef="caseCategory">
          <th mat-header-cell *matHeaderCellDef class="sticky-header">Case Category</th>
          <td mat-cell *matCellDef="let row">{{ row.caseCatagory}}</td>
        </ng-container>

        <!-- Division Column -->
        <ng-container matColumnDef="division">
          <th mat-header-cell *matHeaderCellDef class="sticky-header">Division</th>
          <td mat-cell *matCellDef="let row">{{ row.division }}</td>
        </ng-container>

        <!-- Select Checkbox -->
        <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="sticky-header" style="width: 15%; text-align: center;">Select</th>
        <td mat-cell *matCellDef="let row" style="text-align: center;">
          <mat-checkbox [(ngModel)]="row.selected" (change)="onSelect(row)"></mat-checkbox>
        </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="button-section">
    <button mat-button class="cancel-button" (click)="onCancel()">Cancel</button>
    <button mat-button class="submit-button" color="primary" (click)="onOk()">Select Case</button>
  </div>
</div>
